











































import { ECopyStakeIntegrationType } from '@/api/schema';

export type TRadioOption = {
  value: string;
  title: string;
  description: string;
};

export default {
  name: 'OnboardingGameIntegrationSelectorCopyStake',

  props: {
    savedIntegrationType: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data(): any {
    return {
      selectedIntegrationValue: null,
      integrationOptions: [
        {
          value: ECopyStakeIntegrationType.UNDERGROUND_CASINO,
          title: 'Underground Casino',
          description: 'White-label site, integrated as a single game'
        },
        {
          value: ECopyStakeIntegrationType.DEFAULT_INTEGRATION,
          title: 'Default Integration',
          description: 'Standard integration for all available games'
        }
      ] as TRadioOption[]
    };
  },

  watch: {
    savedIntegrationType: {
      handler(newVal: string | null): void {
        this.selectedIntegrationValue = newVal;
      },
      immediate: true
    }
  },

  methods: {
    onSelectIntegrationTypeHandler(value: ECopyStakeIntegrationType): void {
      if (value) this.selectedIntegrationValue = value;
    },

    onSubmitIntegrationTypeHandler(): void {
      if (this.selectedIntegrationValue)
        this.$emit('updateIntegrationType', this.selectedIntegrationValue);
    }
  }
};
